(() => {
  const CART_TRIGGER_SELECTOR = '#cart-drawer-toggle';
  const RECHARGE_TRIGGER_ATTRIBUTE = 'data-recharge-cart-trigger-observer';
  const RECHARGE_DRAWER_ID = 'recharge-storefront-experiences__cart-drawer';
  const FALLBACK_STORAGE_KEY = 'venjaRechargeCartHandoffFallback';
  const RECHARGE_WAIT_MS = 1600;
  const RECHARGE_POLL_MS = 50;

  let pendingHandoff = false;
  let bypassLink = null;

  function isThemePreview() {
    return Boolean(
      window.Shopify?.designMode
      || new URLSearchParams(window.location.search).has('preview_theme_id')
      || document.getElementById('PBarNextFrame')
    );
  }

  // Send only page-level diagnostic data. Never include cart, customer or product details.
  function track(eventName, details = {}) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
      };

      window.gtag('event', eventName, {
        recharge_handoff_path: window.location.pathname,
        recharge_handoff_environment: isThemePreview() ? 'preview' : 'storefront',
        ...details
      });
    } catch (error) {
      // Measurement must never prevent access to the cart.
    }
  }

  function reportStoredFallback() {
    try {
      const storedFallback = window.sessionStorage.getItem(FALLBACK_STORAGE_KEY);
      if (!storedFallback) return;

      window.sessionStorage.removeItem(FALLBACK_STORAGE_KEY);
      const fallback = JSON.parse(storedFallback);

      if (!fallback.timestamp || Date.now() - fallback.timestamp > 30000) return;

      track('venja_recharge_cart_handoff_fallback', {
        recharge_handoff_source_path: fallback.sourcePath || '',
        recharge_handoff_wait_ms: fallback.waitMs || RECHARGE_WAIT_MS
      });
    } catch (error) {
      // Ignore unavailable or malformed session storage.
    }
  }

  function rechargeOwnsTrigger(link) {
    const drawerHost = document.getElementById(RECHARGE_DRAWER_ID);

    return Boolean(
      link.hasAttribute(RECHARGE_TRIGGER_ATTRIBUTE)
      && drawerHost?.shadowRoot
    );
  }

  function waitForRecharge(link) {
    return new Promise((resolve) => {
      const startedAt = Date.now();

      if (rechargeOwnsTrigger(link)) {
        resolve({ ready: true, waitMs: 0 });
        return;
      }

      const poll = window.setInterval(() => {
        if (rechargeOwnsTrigger(link)) {
          window.clearInterval(poll);
          resolve({ ready: true, waitMs: Date.now() - startedAt });
          return;
        }

        if (Date.now() - startedAt >= RECHARGE_WAIT_MS) {
          window.clearInterval(poll);
          resolve({ ready: false, waitMs: Date.now() - startedAt });
        }
      }, RECHARGE_POLL_MS);
    });
  }

  function continueToCart(link, waitMs) {
    const cartUrl = link.href;
    let fallbackStored = false;

    try {
      window.sessionStorage.setItem(FALLBACK_STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        sourcePath: window.location.pathname,
        waitMs
      }));
      fallbackStored = true;
    } catch (error) {
      // Continue to the cart even when session storage is unavailable.
    }

    if (!fallbackStored) {
      track('venja_recharge_cart_handoff_fallback', {
        recharge_handoff_source_path: window.location.pathname,
        recharge_handoff_wait_ms: waitMs
      });
    }

    window.location.assign(cartUrl);
  }

  async function recoverRechargeHandoff(link) {
    const handoff = await waitForRecharge(link);
    pendingHandoff = false;

    if (!handoff.ready || !link.isConnected) {
      continueToCart(link, handoff.waitMs);
      return;
    }

    track('venja_recharge_cart_handoff_recovered', {
      recharge_handoff_wait_ms: handoff.waitMs
    });

    bypassLink = link;
    link.click();
  }

  function onCartTriggerClick(event) {
    const link = event.target.closest?.(CART_TRIGGER_SELECTOR);
    if (!link) return;

    if (bypassLink === link) {
      bypassLink = null;
      return;
    }

    if (
      event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
      || (link.target && link.target !== '_self')
    ) {
      return;
    }

    if (rechargeOwnsTrigger(link)) return;

    event.preventDefault();

    if (pendingHandoff) return;

    pendingHandoff = true;
    recoverRechargeHandoff(link);
  }

  reportStoredFallback();
  document.addEventListener('click', onCartTriggerClick, { capture: true });
})();
